import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { SelfieComponent } from './../selfie/selfie.component';
import { Router } from '@angular/router';
import { Globals } from '../core/global';
import { EventsService } from '../core/services/events.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit  {

  @ViewChild('selfie', { static: false }) selfieInput: ElementRef;

  logged: boolean;
  newGame: boolean;
  imageUrl: string;
  selfie: any;
  gifUrl: any;

  constructor(
    public router: Router,
    public globals: Globals,
    private events: EventsService
  ) { }

  ngOnInit() {
    this.events.eventStart({ eventType: 'HOME_PAGE_ACCESS', triggerType: 'access' });

    if (localStorage.getItem('msisdn') != null) {
      this.logged = true;

      if (localStorage.getItem('runningGame') != null) {
        this.newGame = false;
      } else {
        this.newGame = true;
      }

    }

    let random = Math.floor(Math.random() * 2) + 1;
    this.gifUrl = `${this.globals.cacheFlyUrl}home/0${random}.gif`

  }

  ngAfterViewInit() {
    this.events.eventStart({ eventType: 'HOME_PAGE_LOADED', triggerType: 'access' });
  }

  startNewGame() {
    this.events.eventStart({ eventType: 'GAME_CLICK', triggerType: 'click' });
    this.router.navigate(['/start-game']);
  }

  onFileChanged(event) {

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (img: any) => { // called once readAsDataURL is completed

        this.imageUrl = img.target.result;

      };
    }
  }

  inputReseted($event) {
    // resetInput

    this.imageUrl = '';

    this.selfieInput.nativeElement.value = '';

  }

}
